import React from 'react';
import { connect } from 'react-redux';
import TopNav from '+/nav/TopNav';
import Flashes from '+/flashes/Container';

export const OnboardingLayout = ({ isSignedIn, children }) => (
  // eslint-disable-next-line implicit-arrow-linebreak
  <div id='layout' className='onboarding'>
    <Flashes />
    <div className='nav-top-container'>
      <TopNav />
    </div>
    <div className='content-container'>
      <div style={{ width: '100%' }}>
        <div
          style={{
            maxWidth: '1500px',
            margin: '0 auto',
          }}
          className='content'
        >
          {children}
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = ({ auth, main }) => ({});

const actions = {};

export default connect(mapStateToProps, actions)(OnboardingLayout);
